"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteDefaultStyles = void 0;
const paletteDefaultStyles = exports.paletteDefaultStyles = `
.palette-root-style {
    background-color: var(--background);
    color: var(--text);
}

.image-block-layout-card {
    width: 100%;
    height: auto;
    aspect-ratio: 1.67;
    object-fit: cover;
}

.nft-block-layout-card {
    background-color: var(--light);
    box-shadow: 0 2px 3px 3px rgba(0, 0, 0, .05), 0 1px 1px 1px rgba(0, 0, 0, .07);
    margin: 10px 0 10px 0;
    border-radius: 5px;
    width: 225px;
}

.nft-block-layout-card-slot-name {
    padding: 15px;
}

.nft-block-layout-card-slot-primary {
    padding: 0 15px 0 15px;
}

.nft-block-layout-mini {
    border-bottom: 1px solid rgba(0, 0, 0, .07);
    margin: 8px 0 8px 0;
    display: flex;
    align-items: flex-start;
    justify-content: stretch;
    flex-wrap: wrap;
    column-gap: 10px;
}

.image-block {
    min-width: 30px;
    min-height: 30px;
    max-width: 100%;
}

.image-block-layout-mini {
    width: 75px;
    height: auto;
}

.nft-block-layout-mini-slot-name {
    flex-grow: 1;
    flex-shrink: 1;
}

.nft-block-layout-mini-slot-primary {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 100%;
}

.layout-block-layout-sidebar {
    display: flex;
    justify-content: stretch;
    column-gap: 15px;
}

.layout-block-layout-sidebar-slot-secondary {
    flex-grow: 0.2; flex-shrink: 0;
}

.layout-block-layout-sidebar-slot-primary {
    flex-grow: 0.7; flex-shrink: 1;
}

.layout-block-layout-sidebar-slot-tertiary {
    flex-grow: 0.1; flex-shrink: 0;
}

.layout-block-layout-flex-slot-primary {
    display: flex;
    column-gap: 15px;
}

.layout-block-layout-grid-slot-primary {
    column-gap: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}


.balance-block {
    background-color: var(--highlight);
    color: var(--highlight-text);
    padding: 15px;
    border-radius: 8px;
}

.layout-block-layout-grid {
    column-gap: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.layout-block-layout-flex {
    column-gap: 8px;
    display: flex;
    justify-content: space-between;
}

.repeat-block-layout-grid {
    column-gap: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.sidebar-left-sidebar {
    flex-grow: 0.2;
    flex-shrink: 0;
}

.sidebar-main-area {
    flex-grow: 0.7;
}

.sidebar-right-sidebar {
    flex-grow: 0.1;
}

.card-content {
    padding: 15px;
}

.main-layout {
    max-width: 1024px;
    margin: 0 auto 0 auto;
}

.spinner-block {
    color: var(--primary);
    margin: 0 8px 0 8px;
    height: 30px;
    width: 30px;
    flex-shrink: 0;
    flex-grow: 0;
}

.success-link {
    font-size: 0.9em;
}

.dumbapp-block {
    display: inline-block;
}

.contract-block {
    line-height: 1;
    padding: 8px;
    background: var(--highlight);
    color: var(--highlight-text);
    border-radius: 5px;
    margin: 5px 0 5px 0;
}

.wallet-block {
    cursor: pointer;
    display: inline-flex;
    padding: 10px;
    margin: 10px;
    background-color: var(--highlight);
}

.contrib-token-block {
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 10px;
}

.checkbox-block {
    display: flex;
}

.block-interaction-click {
    cursor: pointer;
}

.block-interaction-click:hover {
    background-color: var(--primary-transparent);
}

`;
//# sourceMappingURL=palette-default-styles.js.map